import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-birth-date-input',
  standalone: true,
  templateUrl: './birth-date-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BirthDateInputComponent),
      multi: true,
    },
  ],
})
export class BirthDateInputComponent implements ControlValueAccessor {
  @Input() inputId = 'birth-date-input';
  @Input() autocomplete = 'off';
  @Input() readonly = false;

  value = '';
  isDisabled = false;
  isFocused = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private readonly cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value ?? '';
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cdr.markForCheck();
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const masked = this.applyMask(input.value);

    if (input.value !== masked) {
      input.value = masked;
    }

    this.value = masked;
    this.onChange(masked);
  }

  onFocus(): void {
    this.isFocused = true;
    this.cdr.markForCheck();
  }

  onBlur(): void {
    this.isFocused = false;
    this.onTouched();
    this.cdr.markForCheck();
  }

  /** Aplica máscara dd/mm/yyyy a partir de qualquer entrada. Exposto para testes. */
  applyMask(raw: string): string {
    let digits = raw.replace(/\D/g, '');

    if (digits.length > 8) {
      digits = digits.slice(0, 8);
    }

    let masked = '';
    if (digits.length >= 1) masked = digits.slice(0, 2);
    if (digits.length >= 3) masked += '/' + digits.slice(2, 4);
    if (digits.length >= 5) masked += '/' + digits.slice(4, 8);

    return masked;
  }
}
